import React from 'react';
import aboutUs from '../../assets/img/Hero1.avif';
import './AboutUs.css';

const AboutUs = () => {
  return (
    <div className='about-us-wrapper d-flex flex-column flex-lg-row align-items-stretch'>
      <div className='about-us-image'>
        <img src={aboutUs} alt="About Orbi Nexum"/>
      </div>
      <div className='about-us-content'>
        <h2>Who We Are</h2>
        <p>
          Orbi Nexum is a data analytics and collection company focused on transforming how businesses see, use, and scale their data. Our expertise blends the technical depth of data engineering with the spatial intelligence of geolocation analysis.
        </p>

        <div className='section'>
          <h4>Our Mission</h4>
          <p>
            To connect the dots between what your data says and where your business is going — turning every dataset into a strategic asset.
          </p>
        </div>

        <div className='section'>
          <h4>Why We're Different</h4>
          <ul>
            <li><strong>End-to-End Visibility:</strong> From collection and integration to modeling and visualization.</li>
            <li><strong>AI + Spatial Fusion:</strong> We don’t just analyze data — we contextualize it across space and time.</li>
            <li><strong>Enterprise-Grade Infrastructure:</strong> Built with scalability, governance, and security at its core.</li>
          </ul>
        </div>

        <div className='section'>
          <h4>Who We Serve</h4>
          <ul>
            <li><strong>Retailers:</strong> Navigating customer journeys, site optimization, and market segmentation.</li>
            <li><strong>Manufacturers:</strong> Monitoring real-time operations, forecasting demand, and minimizing risk.</li>
            <li><strong>Telecom Providers:</strong> Designing efficient infrastructure, enhancing CX, and increasing ROI.</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
